/** @jsx jsx */

import React, { useEffect, useRef } from "react";
import Modal from '@material-ui/core/Modal';
import { jsx, css } from "@emotion/react";
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";

const theme = createTheme({
    overrides: {
        MuiButton: {
            sizeLarge: {
                "& $label": {
                    font: "normal normal 700 1.25rem/1.875rem Open Sans",
                }
            }
        }
    }
});

const btnDiv = css`
    float: right;
    padding-top: 2em;
    padding-right: 1em;
    padding-bottom: 0.5em;
`;

const titleCss = css`
    text-align: center;
    padding-bottom: 1em;
`;

function getModalStyle() {
    const top = 50;
    const left = 50;
    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        position: 'absolute',
        width: 450,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

type UploaderModalProps = {
    title: string | undefined,
    message: string | undefined,
    isModalOpen: boolean,
    clickHandler: (e: any) => void;
}

const UploaderModal: React.FC<UploaderModalProps> = (props) => {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);


    const handleClose = (e:any) => {
        console.log("handleClose");
        props.clickHandler(e);
    };

    const onModalClose = () => {
        console.log("onModalClose");
    }

    useEffect(() => {

    });

    return (
        <div>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={props.isModalOpen}
                onClose={onModalClose}
            >
                <div style={modalStyle} className={classes.paper}>
                    <h3 css={titleCss} >{props.title}</h3>
                    <p>
                        {props.message}
                    </p>
                    <ThemeProvider theme={theme}>
                        <div css={btnDiv}>
                            <Button size="large" variant="contained" color="primary" onClick={handleClose}>閉じる</Button>
                        </div>
                    </ThemeProvider>
                </div>
            </Modal>
        </div>
    );
};

export default UploaderModal;

